import { render } from "./CPassword.vue?vue&type=template&id=b6e1a112&scoped=true"
import script from "./CPassword.vue?vue&type=script&lang=js"
export * from "./CPassword.vue?vue&type=script&lang=js"

import "./CPassword.vue?vue&type=style&index=0&id=b6e1a112&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e1a112"]])

export default __exports__